/*
 * ## External Dependencies ##
 *  - jQuery ($)
 *
 * Example of Usage:
 *
 * 1 - Simple usage
 *    <DatePicker
 *       selectedDate={this.state.selectedDate}
 *       onSelectDate={this.onSelectDate} />
 *
 * *To customize the calendar, you can change the props defined in `getDefaultProps`;
 *
 */

"use strict";

var PureRenderMixin = React.addons.PureRenderMixin;
var moment = require("moment");

var DatePicker = React.createClass({
  mixins: [PureRenderMixin],
  statics: {
    apiDateFormat: "YYYY-MM-DD HH:mm:ss zz",
    sysDateFormat: "YYYY-MM-DD"
  },
  propTypes: {
    selectedDate: React.PropTypes.string,
    calendarFormat: React.PropTypes.string,
    calendarDayNames: React.PropTypes.array,
    calendarAnimation: React.PropTypes.string,
    shouldCloseOnSelect: React.PropTypes.bool,
    onSelectDate: React.PropTypes.func,
    onClose: React.PropTypes.func
  },
  getDefaultProps: function() {
    var today = moment(new Date());
    return({
      selectedDate: today.format(this.constructor.sysDateFormat),
      calendarFormat: "yy-mm-dd",
      calendarAnimation: "fadeIn",
      calendarDayNames: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      shouldCloseOnSelect: false
    });
  },
  componentDidMount: function() {
    var calendar = this.refs.calendar;
    $(calendar).datepicker({
      dateFormat: this.props.calendarFormat,
      showAnim: this.props.calendarAnimation,
      dayNamesMin: this.props.calendarDayNames,
      defaultDate: this.props.selectedDate,
      onSelect: function(date, time){
        this.props.onSelectDate(date, time);
        if (this.props.shouldCloseOnSelect) {
          this.props.onClose();
        }
      }.bind(this)
    });
  },
  componentWillReceiveProps: function(nextProps) {
    var calendar = this.refs.calendar;
    $(calendar).datepicker("setDate", nextProps.selectedDate);
  },
  render: function() {
    return (
      <div className="bootstrap-agendor">
        <div className="datetimePicker-calendar" ref="calendar"></div>
      </div>
    );
  }
});

module.exports = DatePicker;



// WEBPACK FOOTER //
// ./app/shared/components/DatePicker/date-picker.jsx